// closeRecordingPeriod
import gql from "graphql-tag";

export const MY_TIME_CLOSE_RECORDING_PERIOD = gql`
  mutation closeRecordingPeriod {
    closeRecordingPeriod {
      result
      message
    }
  }
`;
